import ThemeFormController from './theme.form.controller';

export default {
    template: require('./theme.form.html'),
    controller: ThemeFormController
};
